import React from 'react';

import { Button, Image, Table, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import i18n from 'segments/i18n';
import { defaultPaginationConfig } from 'segments/utils/constants/common';

import {
  convertCoachesToTable,
  CoachInfo,
  useDeleteCoachMutation,
  CoachMetainfo
} from 'features/coaches';
import { TimesPriceRow } from 'features/timesPrice';

export interface TableData extends CoachInfo {
  key: number;
}

type Props = {
  items: CoachInfo[];
  itemsTotal?: number;
  isLoading?: boolean;
  currentPage?: number;
  defaultPageSize?: number;
  onPageChange?: (page: number, pageSize: number) => void;
  onCreateClick?: () => void;
  onEditClick: (userId: CoachInfo) => void;
};

export const CoachesTable = (props: Props) => {
  const {
    items,
    itemsTotal = 0,
    isLoading,
    currentPage = 1,
    defaultPageSize = 30,
    onPageChange,
    onEditClick,
    onCreateClick,
  } = props;

  const [deleteCoach, { isLoading: isCoartDeleting }] = useDeleteCoachMutation();
  const { t } = useTranslation(undefined, { keyPrefix: 'table' });

  return (
    <Table<TableData>
      size="small"
      dataSource={convertCoachesToTable(items)}
      loading={isLoading}
      scroll={{ x: 1200 }}
      expandable={{
        expandedRowRender: (record) => (<TimesPriceRow dataSource={record.metainfo.pricing} />)
      }}
      pagination={{
        ...defaultPaginationConfig,
        defaultPageSize,
        current: currentPage,
        total: itemsTotal,
        onChange: onPageChange,
      }}
    >
      <Table.Column<TableData>
        title={t('id', 'ID')}
        dataIndex="id"
        width={50}
      />
      <Table.Column<TableData>
        title={t('name')}
        dataIndex="name"
        width={200}
      />
      <Table.Column<TableData>
        title={t('image', 'Изоброжение')}
        dataIndex="imageUrl"
        render={(url: string) => (
          url === null
            ? <Typography.Text style={{ fontSize: '12px' }}>{i18n.t('image-store.errors.not-seted')}</Typography.Text>
            : <Image height={40} src={url} alt={i18n.t('image-store.errors.not-founded')} style={{ fontSize: '10px' }} />
        )}
        width={100}
      />
      <Table.Column<TableData>
        title={t('rating')}
        dataIndex="metainfo"
        render={(metainfo: CoachMetainfo) => metainfo?.rating}
        width={100}
      />
      <Table.Column<TableData>
        title={t('description')}
        dataIndex="metainfo"
        render={(metainfo: CoachMetainfo) => metainfo?.description}
      />
      <Table.Column<TableData>
        dataIndex="id"
        width={60}
        render={(id: number, coach) => (
          <Button type="primary" onClick={() => onEditClick(coach)}>
            {t('edit', 'Редактировать')}
          </Button>
        )}
      />
      <Table.Column<TableData>
        dataIndex="id"
        width={60}
        title={onCreateClick && <Button type="primary" onClick={onCreateClick}>{t('create')}</Button>}
        render={(id: number) => (
          <Button type="primary" danger disabled={isCoartDeleting} onClick={() => {
            deleteCoach(id);
          }}
          >
            {t('delete', 'Удалить')}
          </Button>
        )}
      />
    </Table>
  );
};
